import { useContext, useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import 'yup-phone-lite';
import PopUpSuccessScheme from '../common/PopUpScheme/PopUpSuccessScheme';
import { SESSION_STORAGE_CONSTANTS, SESSION_STORAGE_OPTIONS } from 'components/common/constants';
import { PopUpSessionEndedScheme } from 'components/common/PopUpScheme/PopUpSessionEndedScheme';
import i18nContext from 'components/i18n-context';
import { AuthorizationBackButton } from 'components/common/AuthorizationBackButton/AuthorizationBackButton';
import Loader from 'components/common/Loader';
import { getErrorMessageForAlert, prepareFieldErrors, replaceSpaces, emailRegExp } from 'services/utils';
import { ROUTE_PATHS } from 'routes/constants';
import Alert from 'uikit/Alert/Alert';
import Button from 'uikit/Button/Button';
import Input from 'uikit/Input/Input';
import { PopUp } from 'uikit/PopUp/PopUp';
import './Login.scss';
import { cleanPhoneNumber } from '../utils';

const Login = ({
  phone,
  setPhone,
  setPassword,
  setUsername,
  sendAuthorizationData,
  error: storeAPIError,
  isLoading
}) => {
  const i18n = useContext(i18nContext);
  const [isSessionEnded, setIsSessionEnded] = useState(
    window.sessionStorage.getItem(SESSION_STORAGE_CONSTANTS.SESSION_ENDED)
  );
  const [countryCode, setCountryCode] = useState(process.env.REACT_APP_DEFAULT_COUNTRY_CODE);
  // const [useEmailLogin, setUseEmailLogin] = useState(true); // Default to email for OAuth2

  const closeSessionEndedPopUp = () => {
    window.sessionStorage.removeItem(SESSION_STORAGE_CONSTANTS.SESSION_ENDED);
    setIsSessionEnded(false);
  };

  const form = useFormik({
    validateOnChange: false,
    initialValues: {
      phone: phone,
      email: '',
      password: ''
    },
    initialStatus: { password: true, username: true },
    validationSchema: Yup.object(
      // useEmailLogin
      //   ? {
      //       email: Yup.string()
      //         .nullable(true)
      //         .required(i18n.getMessage('login.error.emptyEmail'))
      //         .max(50, i18n.getMessage('error.emailSize'))
      //         .trim()
      //         .matches(emailRegExp, { message: i18n.getMessage('login.error.invalidEmail') })
      //         .email(i18n.getMessage('login.error.invalidEmail')),
      //       password: Yup.string()
      //         .nullable(true)
      //         .required(i18n.getMessage('login.error.emptyFiled', { field: 'password' }))
      //         .min(7, i18n.getMessage('error.PASSWORD_REQUIREMENTS'))
      //         .max(30, i18n.getMessage('error.fieldSize', { amount: '30' }))
      //     } :
      {
        phone: Yup.string()
          .nullable(true)
          .required(i18n.getMessage('login.error.emptyPhone'))
          .phone(countryCode.toUpperCase(), i18n.getMessage('error.fieldError.phone.Phone')),
        password: Yup.string()
          .nullable(true)
          .required(i18n.getMessage('login.error.emptyFiled', { field: 'password' }))
          .min(7, i18n.getMessage('error.PASSWORD_REQUIREMENTS'))
          .max(30, i18n.getMessage('error.fieldSize', { amount: '30' }))
      }
    ),
    onSubmit: async (values) => {
      // OAuth2 uses username field (email or phone)
      // if (useEmailLogin) {
      //   if (setUsername) {
      //     setUsername(replaceSpaces(values.email));
      //   }
      // } else {
      //   setPhone(values.phone);
      //   if (setUsername) {
      //     setUsername(values.phone);
      //   }
      // }

      const cleanedPhone = cleanPhoneNumber(values.phone);
      setPhone(cleanedPhone);
      if (setUsername) {
        setUsername(cleanedPhone);
      }

      setPassword(replaceSpaces(values.password));
      await sendAuthorizationData();
    }
  });

  const { values, errors, handleSubmit, handleChange, validateField, submitCount, setFieldValue } = form;

  return (
    <section className={'authorization-form login'}>
      <h1 className={'authorization-title'}>{i18n.getMessage('login.title')}</h1>
      <Alert type={'warning'} message={storeAPIError && getErrorMessageForAlert(i18n, storeAPIError)} />
      <form className={'form'} id={'login'} onSubmit={handleSubmit}>
        <div className={'form-inputs-wrapper'}>
          {/*{useEmailLogin ? (*/}
          {/*  <Input*/}
          {/*    type={'email_phone'}*/}
          {/*    label={i18n.getMessage('login.label.email')}*/}
          {/*    placeholder={i18n.getMessage('login.placeholder.email')}*/}
          {/*    name={'email'}*/}
          {/*    value={replaceSpaces(values.email)}*/}
          {/*    onChange={handleChange}*/}
          {/*    onBlur={() => validateField('email')}*/}
          {/*    initialStatus={submitCount}*/}
          {/*    isRequired={true}*/}
          {/*    autoComplete={'email'}*/}
          {/*    error={errors?.email || (storeAPIError?.fields && i18n.getMessage(`error.${storeAPIError.fields.email}`))}*/}
          {/*    isApiError={!!storeAPIError}*/}
          {/*  />*/}
          {/*) : (*/}
          <Input
            type={'phone'}
            label={i18n.getMessage('register.label.phone')}
            name={'phone'}
            value={values.phone}
            setValue={setFieldValue}
            onChange={handleChange}
            onBlur={() => validateField('phone')}
            setCountryCode={setCountryCode}
            initialStatus={submitCount}
            isRequired={true}
            autoComplete={'tel'}
            error={errors?.phone || (errors && prepareFieldErrors(i18n, errors)?.phone)}
            isApiError={!!storeAPIError}
          />
          {/*)}*/}
          <Input
            type={'password'}
            label={i18n.getMessage('login.label.password')}
            name={'password'}
            placeholder={i18n.getMessage('login.placeholder.password')}
            value={values.password}
            initialStatus={submitCount}
            onChange={handleChange}
            onBlur={() => validateField('password')}
            autoComplete={'current-password'}
            error={errors?.password || (storeAPIError?.fields && storeAPIError.fields.password)}
            isApiError={!!storeAPIError}
          />
        </div>
        {/*<div className={'form-switch-login-method'}>*/}
        {/*  <button*/}
        {/*    type={'button'}*/}
        {/*    className={'link-dark'}*/}
        {/*    onClick={() => {*/}
        {/*      setUseEmailLogin(!useEmailLogin);*/}
        {/*      form.resetForm();*/}
        {/*    }}*/}
        {/*    style={{ marginBottom: '16px', fontSize: '14px' }}*/}
        {/*  >*/}
        {/*    {useEmailLogin*/}
        {/*      ? i18n.getMessage('login.usePhone') || 'Use phone number instead'*/}
        {/*      : i18n.getMessage('login.useEmail') || 'Use email instead'}*/}
        {/*  </button>*/}
        {/*</div>*/}
        <Button
          type={'primary'}
          roleType={'submit'}
          size={'large'}
          fullWidth={true}
          onClick={() => {}}
          isDisabled={isLoading}
        >
          {isLoading ? <Loader /> : i18n.getMessage('login.btn.login')}
        </Button>
        <div className={'form-forgot-password'}>
          <a href={ROUTE_PATHS.PASSWORD_RECOVERY} className={'link-dark'}>
            {i18n.getMessage('login.btn.forgot')}
          </a>
        </div>
      </form>
      <AuthorizationBackButton type={'register'} />
      <PopUp show={isSessionEnded} onClose={() => closeSessionEndedPopUp()}>
        {isSessionEnded === SESSION_STORAGE_OPTIONS.SESSION_ENDED ? (
          <PopUpSessionEndedScheme onClose={() => closeSessionEndedPopUp()} />
        ) : (
          <PopUpSuccessScheme
            onClose={() => closeSessionEndedPopUp()}
            message={i18n.getMessage('popUp.success.passwordRecovery')}
          />
        )}
      </PopUp>
    </section>
  );
};

Login.propTypes = {
  phone: PropTypes.string.isRequired,
  setPhone: PropTypes.func.isRequired,
  setUsername: PropTypes.func,
  setPassword: PropTypes.func.isRequired,
  sendAuthorizationData: PropTypes.func.isRequired,
  error: PropTypes.any,
  isLoading: PropTypes.bool
};

export default observer(Login);
